// External dependencies
import { FC } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { Helmet } from 'react-helmet';
import { withWhiteLabelContext } from 'react-whitelabel';

// Global
import { theme } from './theme';
import Scaffold from './Scaffold';
import 'font-awesome/css/font-awesome.css';
import 'react-toastify/dist/ReactToastify.css';

// Legacy
import Login from '../components/containers/login/login';
import JoinLiveSession from '../components/containers/join-live-session/join-live-session';
import SplitIORoute from '../components/splitio/splitioRoute';
import PrivateRoute from './components/PrivateRoute';

// New UI
import SsoRedirect from './utils/ssoRedirect';
import LogOut from './pages/LogOut';
import SignIn from './pages/SignIn';
import ForgotPassword from './pages/ForgotPassword';
import ResetPasswordRedirect from './pages/ResetPasswordRedirect';
import { authAspects } from './utils/authAspects';
import ChurnZero from './components/ChurnZero';
import WebcoreIframePreloader from './components/WebcoreIframePreloader';
import MixPanelAggregator from './components/MixPanelAggregator';
import KeycloakRedirect from './pages/KeycloakRedirect';

interface IApp {
  label: {
    appTitle: string;
    faveIcon: string;
  };
}

const App: FC<IApp> = ({ label }) => {
  authAspects();

  return (
    <div>
      <ThemeProvider theme={theme}>
        <Helmet>
          <title>{label.appTitle}</title>
          <link rel="shortcut icon" href={label.faveIcon} />
        </Helmet>
        <ChurnZero />
        <MixPanelAggregator />
        <WebcoreIframePreloader />

        <Router>
          <Switch>
            <Route exact path="/auth-redirect/:realm" component={KeycloakRedirect} />
            <SplitIORoute
              exact
              path="/forgot-password/"
              onComponent={ForgotPassword}
              offComponent={Login}
              featureName={'Forgot-Password'}
            />
            <SplitIORoute
              exact
              path="/reset/"
              onComponent={ResetPasswordRedirect}
              offComponent={Login}
              featureName={'Forgot-Password'}
            />

            <Route exact path="/together" component={JoinLiveSession} />
            <Route exact path="/sso/marble" component={SsoRedirect} />

            <SplitIORoute
              path="/login"
              onComponent={SignIn}
              offComponent={Login}
              featureName={'DC-42-UI-refresh-anonymous'}
            />

            <Route exact path="/log-out" component={LogOut} />

            <PrivateRoute>
              {() => {
                return <Scaffold />;
              }}
            </PrivateRoute>
          </Switch>
        </Router>
      </ThemeProvider>
    </div>
  );
};

export default withWhiteLabelContext(App);
